// Component: LatestNewsGrid
// Author: Vijay Radhakrishnan

import React from 'react';
import { Placeholder, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import LatestNewsGridComponent from '@component/LatestNewsGrid';

const LatestNewsGrid = ({ rendering }) => {
  return (
    <>
      <LatestNewsGridComponent
        cards={<Placeholder name="Latest-News-Grid-Card" rendering={rendering} />}
        btnUrl={rendering.fields.Link.value.href}
        btnText={rendering.fields.LinkText.value}
        btnTarget={rendering.fields.Link.value.target}
      ></LatestNewsGridComponent>
    </>
  );
};

export default withSitecoreContext()(LatestNewsGrid);
